import { connect } from 'react-redux';

import { getIsMobile } from 'src/store/view/selectors';

import { submitPackageAction } from 'checkout/store/actions/order';

import { getCanCreateOrder } from 'checkout/store/selectors/order';
import { getIsSubmitButtonLoading } from 'checkout/store/selectors/actualization';

import { isTbankCreditPage } from 'src/utils/uriUtils';
import { payWithTbankCredit } from 'src/store/payment/actions';
import SubmitOrderButton from './SubmitOrderButton';

const mapStateToProps = (state) => ({
  disabled: !isTbankCreditPage() && !getCanCreateOrder(state),
  isLoading: !isTbankCreditPage() && getIsSubmitButtonLoading(state),
  isMobile: getIsMobile(state),
});

const mapDispatchToProps = {
  onClick: isTbankCreditPage() ? payWithTbankCredit : submitPackageAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(SubmitOrderButton);
